import React from 'react';
import DataGrid, { Scrolling, LoadPanel,Column,Button,Editing, Selection,FilterRow,Paging,Pager,Export,ColumnChooser, HeaderFilter, SearchPanel } from 'devextreme-react/data-grid';
import SelectBox from 'devextreme-react/select-box';
import CheckBox from 'devextreme-react/check-box';
import { Link,Redirect } from "react-router-dom";

import { Menu, Dropdown } from 'antd';



const saleAmountEditorOptions = { format: 'currency', showClearButton: true };
const allowedPageSizes = [10,25,50,100];

class Filter extends React.Component  {
  constructor(props) {
    super(props);
    this.applyFilterTypes = [{
      key: 'auto',
      name: 'Immediately'
    }, {
      key: 'onClick',
      name: 'On Button Click'
    }];
    this.state = {
	  displayMode: 'full',
      showPageSizeSelector: true,
      showInfo: true,
      showNavButtons: true,
	  showAction:false,
      showFilterRow: true,
      showHeaderFilter: true,
      currentFilter: this.applyFilterTypes[0].key
    };
    this.dataGrid = null;
    this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
    this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
    this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
    this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
  }

  
   menuList = (res) => {
	 return (
	  <Menu>
		<Menu.Item key="1">
		  <Link class="dropdown-item" to={`${process.env.PUBLIC_URL}/fees-report/view/${res.data.id}`}>
			<i class="ri-edit-line"></i>&nbsp; View
		  </Link>
		</Menu.Item>
	  </Menu>
	 );
   }
  
   RowMenuCell = (res) => {
	    //res.data.idrn (
		return(
			 <Dropdown overlay={this.menuList(res)} trigger={['click']}>
				<a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
				  <i class="ri-more-2-fill action_more"></i>
				</a>
			 </Dropdown>
		);
	}
	
	ProfileCompletition(cellData) {
	  return (
		<>
		<div class="text-center" id="example-caption-5">{cellData.value}%</div>
		{(() => {
			if (cellData.value>75) {
				return (
					<>
						<div class="progress progress-bar-success">
							<div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="100" aria-valuemax="100" style={{width: `${cellData.value}%`}} aria-describedby="example-caption-5"></div>
						</div>
					</>
				)
			}
			else if(cellData.value>50){
				return (
					<>
						<div class="progress progress-bar-primary">
							<div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="100" aria-valuemax="100" style={{width: `${cellData.value}%`}} aria-describedby="example-caption-5"></div>
						</div>
					</>
				)
			}
			else if(cellData.value>25){
				return (
					<>
						<div class="progress progress-bar-warning">
							<div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="100" aria-valuemax="100" style={{width: `${cellData.value}%`}} aria-describedby="example-caption-5"></div>
						</div>
					</>
				)
			}
			else{
				return (
					<>
						<div class="progress  progress-bar-danger">
							<div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="100" aria-valuemax="100" style={{width: `${cellData.value}%`}} aria-describedby="example-caption-5"></div>
						</div>
					</>
				)
			}
		})()}
		
		</>
	  );
	}
	
	Status(cellData) {
	  return (
		<>
			{(() => {
					if (cellData.value=='Admitted') {
						return (
							<>
								<div class="chip chip-green">
									<div class="chip-body">
										<span class="chip-text">Admitted</span>
									</div>
								</div>
							</>
						)
					}
					else if(cellData.value=='Lost'){
						return (
							<>
								<div class="chip chip-red">
									<div class="chip-body">
										<span class="chip-text">Lost</span>
									</div>
								</div>
							</>
						)
					}
					else if(cellData.value=='On Hold'){
						return (
							<>
								<div class="chip chip-orange">
									<div class="chip-body">
										<span class="chip-text">On Hold</span>
									</div>
								</div>
							</>
						)
					}
					else if(cellData.value=='Open'){
						return (
							<>
								<div class="chip chip-green">
									<div class="chip-body">
										<span class="chip-text">Open</span>
									</div>
								</div>
							</>
						)
					}
					else if(cellData.value=='Other'){
						return (
							<>
								<div class="chip chip-blue">
									<div class="chip-body">
										<span class="chip-text">Other</span>
									</div>
								</div>
							</>
						)
					}
					else{
						return (
							<>
								{cellData.value}
							</>
						)
					}
				})()}
		</>
	  );
	}
	
	Priority(cellData) {
	  return (
		<>
			{(() => {
				if (cellData.value=='Potential') {
					return (
						<>
							<div class="chip chip-green">
								<div class="chip-body">
									<span class="chip-text">Potential</span>
								</div>
							</div>
						</>
					)
				}
				else if(cellData.value=='Needs Follow up'){
					return (
						<>
							<div class="chip chip-blue">
								<div class="chip-body">
									<span class="chip-text">Needs Follow up</span>
								</div>
							</div>
						</>
					)
				}
				else if(cellData.value=='Tentative'){
					return (
						<>
							<div class="chip chip-orange">
								<div class="chip-body">
									<span class="chip-text">Tentative</span>
								</div>
							</div>
						</>
					)
				}
				else if(cellData.value=='Might Turn Up'){
					return (
						<>
							<div class="chip chip-red">
								<div class="chip-body">
									<span class="chip-text">Might Turn Up</span>
								</div>
							</div>
						</>
					)
				}
				else if(cellData.value=='Cold Lead'){
					return (
						<>
							<div class="chip chip-red">
								<div class="chip-body">
									<span class="chip-text">Cold Lead</span>
								</div>
							</div>
						</>
					)
				}else{
					return (
						<>
							{cellData.value}
						</>
					)
				}
			})()}
		</>
	  );
	}

  render() {
	const { data } = this.props;
    return (
      <div class="dx-viewport">
        <DataGrid id="gridContainer"
		  height={600}
          ref={(ref) => this.dataGrid = ref}
          dataSource={data}
          keyExpr="id"
		  allowColumnReordering={true}
          allowColumnResizing={true}
          columnAutoWidth={true}
          showBorders={true}
		  rowAlternationEnabled={true}
		  onSelectionChanged={this.props.onSelectionChanged}
		  >
          <FilterRow visible={this.state.showFilterRow} applyFilter={this.state.currentFilter} />
          <HeaderFilter visible={this.state.showHeaderFilter} fixed={true}  />
		  <Export enabled={true} allowExportSelectedData={true} />
		  <Paging defaultPageSize={10} />
          <Pager
            visible={true}
            allowedPageSizes={allowedPageSizes}
            displayMode={this.state.displayMode}
            showPageSizeSelector={this.state.showPageSizeSelector}
            showInfo={this.state.showInfo}
            showNavigationButtons={this.state.showNavButtons} />
			
          <ColumnChooser allowSearch={true} enabled={true} mode="select" />
		  
			<Column fixed={true} type="custom" caption="Action" alignment="center" cellRender={this.RowMenuCell.bind(data.id)}> </Column>
          
			<Column fixed={true} dataField="sr_no" caption="#" alignment="left">
			<HeaderFilter allowSearch={true} />
			</Column>
		   <Column fixed={true} dataField="added_date" caption="Added Date" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
		  
		   <Column fixed={true} dataField="paid_by" caption="Paid By" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
		  <Column dataField="name" caption="Student Name" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
          <Column dataField="class" caption="Class" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
          <Column dataField="pay_tracking_id" caption="Tracking Id" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
          <Column dataField="academic_year" caption="Academic Year" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
          <Column dataField="amount" caption="Amount" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
          <Column dataField="type" caption="Fees Type" alignment="left">
            <HeaderFilter allowSearch={true} />
          </Column>
		  
        </DataGrid>
      </div>
    );
  }
  calculateFilterExpression(value, selectedFilterOperations, target) {
    let column = this;
    if (target === 'headerFilter' && value === 'weekends') {
      return [[getOrderDay, '=', 0], 'or', [getOrderDay, '=', 6]];
    }
    return column.defaultCalculateFilterExpression.apply(this, arguments);
  }
  orderHeaderFilter(data) {
    data.dataSource.postProcess = (results) => {
      results.push({
        text: 'Weekends',
        value: 'weekends'
      });
      return results;
    };
  }
  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value
    });
    this.clearFilter();
  }
  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value
    });
    this.clearFilter();
  }
  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value
    });
  }
  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }
}

function getOrderDay(rowData) {
  return (new Date(rowData.OrderDate)).getDay();
}

export default Filter;
